var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1995 1999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-10,.cls-2{fill:#fff;}.cls-3{fill:#9192ff;}.cls-4{fill:#a8d3f4;}.cls-5{fill:#088cfc;}.cls-6{clip-path:url(#clip-path);}.cls-7{opacity:0.8;}.cls-8{fill:#fff2e0;opacity:0.7;}.cls-9{fill:#ffa121;}.cls-10{opacity:0.4;}.cls-11{fill:#d1d1ff;}.cls-12{fill:#93acbf;}.cls-13{fill:#586773;}.cls-14{fill:#f9e181;}.cls-15{fill:#ffbc96;}.cls-16{fill:#d28572;}.cls-17{fill:#88c4f2;}.cls-18,.cls-19{fill:#1b1b43;}.cls-18{opacity:0.3;}.cls-20{fill:#fe5b52;opacity:0.2;}.cls-21{fill:#c5c5ff;}.cls-22{fill:#40a87b;}.cls-23{fill:#bdbdef;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988.78,1083.54a57.86,57.86,0,0,0,57.85,57.85H1689.2a57.86,57.86,0,0,0,57.85-57.85v-391H988.78Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -2,
    y: 2,
    width: 2000,
    height: 2000
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.91,1140.43l-1.72-1.81L598,1128.27l1.73,1.8Zm21.68-20.77-1.76-1.78c3.53-3.47,7.06-7.05,10.52-10.65l1.8,1.74C617.68,1112.57,614.13,1116.17,610.59,1119.66ZM631.42,1098l-1.85-1.68c3.31-3.64,6.65-7.41,9.93-11.2l1.89,1.63C638.1,1090.54,634.75,1094.32,631.42,1098Zm19.65-22.75-1.93-1.58c3.12-3.8,6.27-7.74,9.35-11.69l2,1.54C657.36,1067.47,654.2,1071.42,651.07,1075.23Zm18.5-23.68-2-1.5c2.93-3.94,5.89-8,8.8-12.11l2,1.45C675.49,1043.5,672.52,1047.59,669.57,1051.55ZM687,1027l-2.07-1.4q4.2-6.2,8.27-12.48l2.1,1.36Q691.19,1020.82,687,1027Zm137-17.33a36.58,36.58,0,0,1-13.47-2.57l.92-2.32a34.19,34.19,0,0,0,12.55,2.39c.62-.06,1.08,0,1.62,0l.12,2.5C825.1,1009.7,824.41,1009.66,823.94,1009.71Zm16.6-4.27-1.25-2.17a27.14,27.14,0,0,0,10-10.07l2.17,1.25A29.75,29.75,0,0,1,840.54,1005.44Zm-137.23-3.61-2.12-1.32q3.94-6.36,7.77-12.8l2.15,1.28Q707.27,995.44,703.31,1001.83Zm94.49-3.48a43.86,43.86,0,0,1-8.23-13l2.3-1a41.55,41.55,0,0,0,7.76,12.23Zm57.77-18.8-2.5-.06v-.66a25.89,25.89,0,0,0-2.21-10.62c-.37-.83-.79-1.65-1.24-2.44l2.18-1.23c.48.86.93,1.74,1.34,2.64a28.49,28.49,0,0,1,2.43,11.65Zm-135.91-2.62-1.92-1.61A95.54,95.54,0,0,1,728.4,964.5l1.63,1.89A93,93,0,0,0,719.66,976.93Zm66-6.35a62,62,0,0,1-.43-7.24,64.14,64.14,0,0,1,.51-8l2.48.31a63,63,0,0,0-.49,7.72,57,57,0,0,0,.42,6.94ZM742,957.64l-1.31-2.13a103.82,103.82,0,0,1,13.46-7l1,2.3A101.28,101.28,0,0,0,742,957.64ZM840,955.06A55,55,0,0,0,827.24,948l.93-2.32a57.57,57.57,0,0,1,13.36,7.44Zm-70.94-9.13-.65-2.41a108.3,108.3,0,0,1,14.87-2.94l.31,2.48A106.64,106.64,0,0,0,769.07,945.93Zm44-2.07a90.61,90.61,0,0,0-14.7-1.54l.06-2.5a93.31,93.31,0,0,1,15.11,1.58Zm-21.37-2.53-2.35-.84a75.62,75.62,0,0,1,6.6-13.73l2.13,1.31A72.79,72.79,0,0,0,791.71,941.33Zm15.29-25-1.84-1.7c.73-.78,1.48-1.55,2.24-2.31a81.37,81.37,0,0,1,9.15-7.78l1.48,2a78.17,78.17,0,0,0-8.87,7.54C808.42,914.83,807.7,915.58,807,916.33Zm23.66-17.43-1.11-2.24a92.5,92.5,0,0,1,14.11-5.6l.73,2.39A90,90,0,0,0,830.66,898.9Zm28.2-9.18-.62-2.42c4.89-1.25,9.75-2.57,14.45-3.9l.68,2.41C868.65,887.15,863.77,888.46,858.86,889.72Zm28.92-8.22-.75-2.38c4.82-1.52,9.6-3.11,14.2-4.71l.82,2.36C897.43,878.38,892.63,880,887.78,881.5Zm28.39-9.93-.9-2.33c4.68-1.82,9.33-3.72,13.83-5.66l1,2.29C925.56,867.83,920.88,869.74,916.17,871.57Zm27.62-11.93-1.08-2.25,13.49-6.55,1.09,2.25Zm27-13.11-1.09-2.25,13.49-6.56,1.09,2.25Zm27-13.12-1.09-2.25,13.49-6.56,1.09,2.25Zm27-13.12-1.09-2.24,13.49-6.56,1.09,2.25Zm27-13.11-1.09-2.25,13.49-6.56,1.09,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1005.63,342.29a13,13,0,0,0,.06,1.53h328.77c-.86-27.1-24.45-48.83-53.38-48.83a55.76,55.76,0,0,0-25.58,6.13c.4-21.09-9.73-41.29-28.41-52.13-28-16.24-64.68-5.22-81.83,24.63a65.62,65.62,0,0,0-8.64,28.29c-13.67-6.25-30.61-10-49-10C1042.34,291.93,1005.63,314.49,1005.63,342.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M458.66,1110.54H187.56l0-1c.72-22.94,20.34-40.91,44.66-40.91a47.2,47.2,0,0,1,20,4.45c.18-17.56,9.18-33.55,23.75-42a47.13,47.13,0,0,1,36.12-4.57,52.81,52.81,0,0,1,32.18,25.09,54.52,54.52,0,0,1,7.1,22.24c11.54-5.05,25.1-7.71,39.29-7.71,37.56,0,68.11,18.93,68.11,42.19a12.37,12.37,0,0,1-.05,1.36Zm-269.15-1.87H456.94v-.31c0-22.23-29.71-40.32-66.24-40.32-14.43,0-28.17,2.8-39.73,8.1l-1.24.56-.09-1.35a52.53,52.53,0,0,0-6.95-22.78,51,51,0,0,0-31.05-24.21,45.29,45.29,0,0,0-34.69,4.38c-14.4,8.36-23.14,24.4-22.81,41.87l0,1.57-1.4-.71a45.06,45.06,0,0,0-20.52-4.93C209.29,1070.54,190.71,1087.21,189.51,1108.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M988.78,1083.54a57.86,57.86,0,0,0,57.85,57.85H1689.2a57.86,57.86,0,0,0,57.85-57.85v-391H988.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M949.1,792.27C958,763.85,986,742,1016.65,739.73s61.9,15,75.31,41.77c16.31-.15,32.37,8.89,40.29,22.67a43.6,43.6,0,0,1-1.4,45c19.41,3.37,36.84,16.14,45.43,33.31a59.67,59.67,0,0,1-1.22,55c21.37-10.86,48.7-9.88,69.2,2.5s33.42,35.69,32.7,59c13.31-20.88,38.83-33.89,64.2-32.73s49.55,16.43,60.84,38.43c11.91-35.64,43.66-64.41,81.24-73.6s79.73,1.49,107.85,27.33c42.3,6.62,73.12,52.54,62.1,92.51,22.85,18.91,34.53,49.65,29.75,78.31s-25.84,54.26-53.66,65.21L901.59,1194l-62-277.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M937.56,884.47c8.58-28.42,35.69-50.26,65.3-52.59s59.8,15,72.73,41.71a44,44,0,0,1,37.52,67.63,60.54,60.54,0,0,1,42.65,88.31,67.13,67.13,0,0,1,98.39,61.44c12.88-20.89,37.54-33.92,62-32.78s47.87,16.39,58.75,38.38c11.54-35.65,42.24-64.44,78.55-73.66s77,1.42,104.18,27.24c40.86,6.58,70.6,52.48,59.93,92.46,22.05,18.89,33.31,49.62,28.67,78.28s-25,54.28-51.89,65.25l-703.05.11-59.72-277.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1496.5,705.09c-210.61,198.06-360,251.47-548.11,270.56l-12.5,200,197.5,67.5c172.5-5,338.13-254.72,440.44-468.95l-77.33-69.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1526.16,707.67c-34.24,40.51-85.88,79.26-146.79,131.6l83.11-33.87c-10.19,16.88-25,40.52-33.35,50.65,19.15-8.84,50-28.29,60.18-38.6,0,14.39-17.34,38.46-24.9,51.61,44.33-37.94,84.66-84.26,97.68-124.94l-35.93-36.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1535.87,709.72c-20.26,26.85-50.57,52.73-86.4,87.59l48.5-23c-6.08,11.15-14.92,26.76-19.85,33.47,11.19-6,29.25-19,35.27-25.87-.15,9.41-10.44,25.34-15,34,26.07-25.27,49.91-56,57.88-82.73l-20.44-23.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1221.38,847.31c.27,6.27,0,16.84-6.26,20.46-10.44,6-18.65-8.64-22.49-16-4.57-8.81-3.4-19.75,6.94-23.67C1213.23,822.9,1220.88,835.63,1221.38,847.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1716.5,1037.42c.27,6.26,0,16.83-6.26,20.46-10.44,6-18.65-8.64-22.49-16-4.57-8.81-3.4-19.74,6.94-23.67C1708.35,1013,1716,1025.74,1716.5,1037.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1165.89,
    cy: 776.49,
    r: 8.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1610.89,
    cy: 934.4,
    r: 13.32,
    transform: "translate(-247.53 814.6) rotate(-26.43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1689.2,1142.64H1046.64a59.18,59.18,0,0,1-59.11-59.1V691.33H1748.3v392.21A59.17,59.17,0,0,1,1689.2,1142.64ZM990,693.83v389.71a56.67,56.67,0,0,0,56.61,56.6H1689.2a56.66,56.66,0,0,0,56.6-56.6V693.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1689.2,541.11H1046.63A57.85,57.85,0,0,0,988.78,599v93.62h758.27V599A57.84,57.84,0,0,0,1689.2,541.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1748.3,693.83H987.53V599a59.17,59.17,0,0,1,59.11-59.1H1689.2a59.16,59.16,0,0,1,59.1,59.1ZM990,691.33H1745.8V599a56.66,56.66,0,0,0-56.6-56.6H1046.64A56.67,56.67,0,0,0,990,599Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 1065.17,
    cy: 616.85,
    r: 31.72,
    transform: "translate(242.84 1532.74) rotate(-78.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1158.59,
    cy: 616.85,
    r: 31.72,
    transform: "matrix(0.78, -0.62, 0.62, 0.78, -131.58, 858.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1158.59,649.81a33,33,0,1,1,33-33A33,33,0,0,1,1158.59,649.81Zm0-63.43a30.47,30.47,0,1,0,30.46,30.47A30.51,30.51,0,0,0,1158.59,586.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1243.47,
    y: 586.57,
    width: 186.83,
    height: 60.55,
    rx: 30.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1400,648.37H1273.74a31.53,31.53,0,0,1,0-63H1400a31.53,31.53,0,0,1,0,63Zm-126.29-60.55a29,29,0,0,0,0,58H1400a29,29,0,0,0,0-58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1657.75,472.11c-50.64,44.33-138,13.78-165.12,49.17l77.55,61.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1492.63,521.28h0a30,30,0,0,0,5.48,30.26l55,63,17.12-31.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1772.53,563c-31.54,59.45,18.21,137.46-10,172L1685,673.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1762.51,735h0a30,30,0,0,1-30.71,1.6l-73.86-39.06,27-23.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1811.92 395.92 1742.88 421.26 1803.08 468.93 1811.92 395.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1803.08,468.93c-9.65,109.26-90.37,211.2-188.42,267.83l-89.34-70.68c37.49-118,107.31-202.36,217.56-244.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1525.32 666.08 1486.56 692.91 1597.41 780.69 1614.66 736.76 1525.32 666.08"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1716.96,
    cy: 515.84,
    r: 41.47,
    transform: "translate(-46.97 195.53) rotate(-6.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1720.09,545.23l-.26-2.49a27.25,27.25,0,0,0,7-1.68l.9,2.33A30,30,0,0,1,1720.09,545.23Zm-7.8-.2a29,29,0,0,1-7.48-2.24l1-2.28a26.22,26.22,0,0,0,6.84,2Zm22.23-5.41-1.48-2a27.12,27.12,0,0,0,5.13-5l2,1.55A29.14,29.14,0,0,1,1734.52,539.62Zm-36.34-1a29,29,0,0,1-5.32-5.7l2-1.45a26.82,26.82,0,0,0,4.88,5.22Zm45-9.17-2.21-1.16a27.15,27.15,0,0,0,2.43-6.72l2.44.54A29.6,29.6,0,0,1,1743.18,529.49Zm-54-3.44a29.63,29.63,0,0,1-1.7-7.62l2.49-.22a27.18,27.18,0,0,0,1.55,7ZM1744,514.49a27.43,27.43,0,0,0-1.29-7l2.37-.77a29.69,29.69,0,0,1,1.42,7.67Zm-53.66-3.42-2.46-.44a29.37,29.37,0,0,1,2.38-7.44l2.26,1.07A27.07,27.07,0,0,0,1690.32,511.07ZM1739.6,501a27,27,0,0,0-4.68-5.4l1.66-1.87a29.62,29.62,0,0,1,5.11,5.9Zm-43.21-2.75-1.9-1.62a29.7,29.7,0,0,1,5.81-5.22l1.41,2.07A27.09,27.09,0,0,0,1696.39,498.26Zm32.61-6.65a27,27,0,0,0-6.76-2.31l.48-2.45a29.34,29.34,0,0,1,7.39,2.52Zm-20.91-1.33-.81-2.36a29.24,29.24,0,0,1,7.64-1.56l.18,2.49A27.47,27.47,0,0,0,1708.09,490.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1546.71,
    y: 651.4,
    width: 15.97,
    height: 138.72,
    rx: 6.73,
    transform: "translate(783.31 -809.45) rotate(38.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1650.37,1632h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0a48,48,0,0,1-15.11-2.58l.81-2.36a45.61,45.61,0,0,0,14.32,2.44Zm301.81,0-.09-2.5a45.16,45.16,0,0,0,14.25-2.85l.88,2.34A48.08,48.08,0,0,1,1652.17,1632Zm-330.44-9.79a48,48,0,0,1-10.55-11.12l2.06-1.41a45.75,45.75,0,0,0,10,10.55Zm358.78-.84-1.57-1.94a45.5,45.5,0,0,0,9.7-10.83l2.11,1.36A48,48,0,0,1,1680.51,1621.33Zm-375.84-24.16a48,48,0,0,1-1.82-13.13v-2h2.5v2a45.61,45.61,0,0,0,1.72,12.44Zm392.18-1.32-2.42-.61a45.76,45.76,0,0,0,1.39-11.2v-3.37h2.5V1584A47.77,47.77,0,0,1,1696.85,1595.85ZM1305.35,1567h-2.5v-15h2.5Zm393-1.32h-2.5v-15h2.5Zm-393-28.68h-2.5v-15h2.5Zm393-1.32h-2.5v-15h2.5Zm-393-28.68h-2.5v-15h2.5Zm393-1.32h-2.5v-15h2.5Zm-393-28.68h-2.5v-15h2.5Zm393-1.32h-2.5v-15h2.5Zm-393-28.68h-2.5v-15h2.5Zm393-1.32h-2.5v-15h2.5Zm-393-28.68h-2.5v-10a49,49,0,0,1,.27-5.13l2.49.27a46.54,46.54,0,0,0-.26,4.86Zm393-1.32h-2.5V1407a46.83,46.83,0,0,0-.41-6.15l2.48-.33a49.9,49.9,0,0,1,.43,6.48Zm-388.87-27.55-2.28-1a47.92,47.92,0,0,1,8.53-12.75l1.83,1.71A45,45,0,0,0,1309.45,1388.12Zm381.72-1.16a45.41,45.41,0,0,0-8.42-11.85l1.79-1.75a48.07,48.07,0,0,1,8.88,12.49ZM1329,1367.11l-1.2-2.19a47.53,47.53,0,0,1,14.46-5.11l.44,2.46A45.25,45.25,0,0,0,1329,1367.11Zm342-.6a45.24,45.24,0,0,0-13.83-4.45l.37-2.47a47.79,47.79,0,0,1,14.6,4.69Zm-28.62-5h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Zm-30,0h-15v-2.5h15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1266.95,
    y: 1310.77,
    width: 392.97,
    height: 277.89,
    rx: 36.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1335.28,
    y: 1473.09,
    width: 42.55,
    height: 86.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1406.53,
    y: 1475.86,
    width: 42.55,
    height: 83.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1477.79,
    y: 1432.17,
    width: 42.55,
    height: 127.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1549.05,
    y: 1394.82,
    width: 42.55,
    height: 164.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1349.28,
    y: 1349.91,
    width: 228.31,
    height: 9.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M654.13,1039.49a118.48,118.48,0,0,0-43.57-62.55l-8.44-6.22L609.29,1119l55.4-42.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M832.16,1218.67l-12.31-24.1a24.42,24.42,0,0,0-15.26-12.45l-36.21-10-93.16-59.48-10.53-36.51L609.29,1119l.5,10.41a54.78,54.78,0,0,0,33,47.66l90.46,39,43,1c13.86,4.77,18.64,16.72,27.24,12.42,3.2-1.6-9.32-22.22-9.32-22.22L815,1230.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 659.72,
    y: 1118.34,
    width: 18.81,
    height: 2.87,
    transform: "translate(-617.54 905.05) rotate(-49.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M670.13,1278.71l67.78-6c44.12-3.89,82.5,31.73,84.65,78.58l15.31,333.81L744.38,1688Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "751.9 1684.71 754.76 1776.92 893.31 1776.92 824.99 1720.07 820.69 1675.64 751.9 1684.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 792.03,
    y: 1728.43,
    width: 36.79,
    height: 5.73,
    transform: "translate(-888.18 854.43) rotate(-37.61)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "720.37 1684.71 723.23 1776.92 861.78 1776.92 793.46 1720.07 789.16 1675.64 720.37 1684.71"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 760.5,
    y: 1728.43,
    width: 36.79,
    height: 5.73,
    transform: "translate(-894.74 835.18) rotate(-37.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M823.56,1693.79H708.9l-81.72-251.45-11.44-35.2-163.39-.72c-10.09-.14-19.75-4.81-28-11.72C407,1380.05,399,1357,402.18,1334.53l14.34-102.25,242.73,31.56a109,109,0,0,1,92.68,85.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "649.42 1407.14 627.18 1442.34 615.74 1407.14 649.42 1407.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M619.41,1213.77c-1.18,4.73-2.41,9.46-3.67,14.22l-8.6,35.11-113.23-4.7L412.39,1255a35,35,0,0,1-32.85-42.14l38-182.91A69.44,69.44,0,0,1,479,971.69l93-9.57,30.09,8.6c29.38,15.76,29.41,44.34,30.82,63.06C639.1,1115.7,631.5,1165.32,619.41,1213.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M542.64,1207.92c-1.17,4.73,74.36,15.31,73.1,20.07l-8.6,35.11-113.23-4.7c-39.55-29.84-54.37-94.77-68.79-176.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M520.14,1015a68.09,68.09,0,0,0,16.92,13.41,56,56,0,0,0,20.22,6.83c7,.91,14.41.32,20.57-3,6.3-3.13,10.3-9.74,11-16.89l1.12.07a23.06,23.06,0,0,1-2.85,10.91,21.69,21.69,0,0,1-8.09,8.1c-6.73,3.89-14.73,4.6-22.16,3.65a55.07,55.07,0,0,1-21.07-7.54,59.69,59.69,0,0,1-16.57-14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M635.44,1126.78l-2.14-.15c2.06-28.84,0-64.29-6.2-105.35l2.12-.32C635.42,1062.18,637.51,1097.78,635.44,1126.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 721.32,
    y: 1228.46,
    width: 106.54,
    height: 21.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1012.27 1249.48 798.24 1249.48 896.66 1061.25 1110.69 1061.25 1012.27 1249.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M543.72,811.63c-25.08-24.73-72.38-14.34-71.66,27.23-51.6,13.61-54.47,70.23-33.69,99.25l17.92,1.43,3.94-21.14,10.39,21.5,50.17,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M585.64,904.07v79c0,.72,0,1.41-.09,2.1a26.51,26.51,0,0,1-33,23.59,53.32,53.32,0,0,1-40-52.06l.4-52.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M585.64,938.21V983c0,.72,0,1.41-.09,2.1C564.43,981.67,540,957.22,534,930.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M628.38,909.92a142,142,0,0,1-4.5,18.8c-6.31,20-17.63,36.66-37.9,33.77-47.64-6.82-74.15-55.9-74.15-55.9l32.59-37.26,21.87-29.41,65.56,28.32A247,247,0,0,1,628.38,909.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M525.92,894c20.91-.67,37.08-11.32,44-41.57,0,0,48.73,42,72.61,19.59,20-18.8-13.93-62.06-70.1-67.22A79.6,79.6,0,0,0,515.5,822.2c-27.23,21.82-29.83,72.55-4.39,90.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M501.44,841c-1.37-4.94-.35-10.42,1.86-15.13a33.53,33.53,0,0,1,9.81-12.07,34.46,34.46,0,0,1,14-6.57,25.37,25.37,0,0,1,15.14,1.16,83.89,83.89,0,0,0-13,5.24,69.9,69.9,0,0,0-11,7,63.8,63.8,0,0,0-9.38,8.86A52.45,52.45,0,0,0,501.44,841Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 519.65,
    cy: 897.39,
    rx: 16.3,
    ry: 19.7,
    transform: "translate(-296.27 257.38) rotate(-21.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M519.65,908.21a23.46,23.46,0,0,0-.63-9.84c-1-3-2.93-5.7-5.15-8.44l.7-.87a14.32,14.32,0,0,1,6.16,19.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M598,897.64a4.87,4.87,0,1,1-4.84-5.36A5.12,5.12,0,0,1,598,897.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M623.37,901.86a4.33,4.33,0,1,1-3.69-5.26A4.56,4.56,0,0,1,623.37,901.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M597.71,884.19c.19,2.5-3.81,2.74-9.72,2.92s-10,2-10,.41,4.32-5.65,10.14-6.63C594.11,879.87,597.47,881.21,597.71,884.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M616.56,886.6c-.44,2.47,2.51,3.1,6.87,3.87s7.18,3,7.4,1.41-2.55-6-6.76-7.6S617.08,883.66,616.56,886.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M609.54,906.31a41.83,41.83,0,0,0,3.64,3.77l1.93,1.8a10.82,10.82,0,0,1,2,2.28,4,4,0,0,1,.61,1.91,3.75,3.75,0,0,1-.47,2,7.17,7.17,0,0,1-2.31,2.34,14.6,14.6,0,0,1-5.37,1.94l-.41-1a41.15,41.15,0,0,0,4.27-2.92,5.47,5.47,0,0,0,1.33-1.61c.23-.47.16-.63-.1-1.19-.64-1-2.26-2.44-3.33-3.89a16.23,16.23,0,0,1-2.81-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M585.28,924c2.93,3.35,6,6.44,9.64,8.4a20.18,20.18,0,0,0,12.19,2.11l.3,1.08a15,15,0,0,1-6.93,1.31,15.78,15.78,0,0,1-6.91-2,22.23,22.23,0,0,1-9.24-10.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 568.09,
    cy: 909.08,
    r: 11.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M628.38,909.92a142,142,0,0,1-4.5,18.8,11.82,11.82,0,0,1,4.5-18.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "493.44 1049.78 425.12 1082.27 446.54 1133.06 518.18 1100.03 493.44 1049.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M746.5,1225.94c-1.89-1-3.08-1.59-3.08-1.59l.68-1.35s1.27.61,3.1,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M774.83,1233c-2.21,4.36-19.12-3.35-27-7.22,6.1,3.38,16.62,10,11.95,13.67-3.75,2.9-12.07-3.27-39.3-14.56,4.13,1.95,28.47,13.53,22.33,17.91-6.68,4.76-35.34-5.73-35.34-5.73l-24.86,13.36H654l-103.14.66a74.9,74.9,0,0,1-19.12-2.41,85.63,85.63,0,0,1-33.53-17.37,84,84,0,0,1-15.91-17.86,95.14,95.14,0,0,1-8.52-15.94l-27.2-64.43L518.16,1100l37.38,75.88,123.26,26.77,34.4-8.6c7.4-1.86,17.86,1.27,24.37,5.25C753.45,1209,776.89,1228.84,774.83,1233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M533.56,1238a31.07,31.07,0,0,1-1.87,10.66,85.63,85.63,0,0,1-33.53-17.37,84,84,0,0,1-15.91-17.86A31.54,31.54,0,0,1,533.56,1238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M678.63,1202.13a235.2,235.2,0,0,1,26-7.14,92.88,92.88,0,0,1,13.45-1.91,40.12,40.12,0,0,1,6.92.18c1.15.23,2.3.53,3.45.8s2.16.83,3.24,1.24c8.39,3.8,15.69,9.24,22.76,14.83s13.73,11.68,20.21,18l.3.29.06.37a5.41,5.41,0,0,1-.68,3.88,4.51,4.51,0,0,1-1.56,1.37,4.38,4.38,0,0,1-1.79.63,14.9,14.9,0,0,1-6.43-.63,63.47,63.47,0,0,1-11.13-4.68c-3.51-1.87-7-3.82-10.32-5.93s-6.65-4.28-10-6.42l1.52-2.43a180.27,180.27,0,0,1,17,11.27,46.38,46.38,0,0,1,7.69,7.07,10.11,10.11,0,0,1,1.49,2.52,4.62,4.62,0,0,1,.34,1.75,3.35,3.35,0,0,1-.73,2,5.29,5.29,0,0,1-2.91,1.62,17.12,17.12,0,0,1-2.76.39l-.28,0-.31-.13-31.11-13,.93-2.19a107.82,107.82,0,0,1,14.22,7.68c2.22,1.58,4.55,3,6.19,5.76a3.35,3.35,0,0,1,.25,2.74,3.67,3.67,0,0,1-1.84,1.9,10.41,10.41,0,0,1-4.29,1c-5.57.13-10.81-1.18-16-2.46s-10.28-3-15.31-4.81l.38-1.06c5,1.69,10.14,3.17,15.29,4.4s10.43,2.29,15.54,2c2.44-.1,5.35-1.17,4.16-2.78-1.12-1.88-3.43-3.48-5.54-4.89a105.61,105.61,0,0,0-14-7.3l.94-2.19,31.23,12.76-.59-.1a14,14,0,0,0,2.24-.32,3,3,0,0,0,1.47-.7c.43-.18-.15-1.72-1.13-2.87A43.42,43.42,0,0,0,750,1228a175.26,175.26,0,0,0-16.77-11l1.51-2.42c3.3,2.11,6.5,4.39,9.85,6.39s6.7,4,10.12,5.87a60.94,60.94,0,0,0,10.58,4.51,12.46,12.46,0,0,0,5.18.6l.55-.09a3.45,3.45,0,0,0,.43-.22c.33-.09.43-.36.65-.52a2.88,2.88,0,0,0,.31-1.81l.36.66c-6.34-6.26-13-12.26-19.9-17.93s-14.1-11.06-22-14.78l-3-1.21c-1-.25-2.06-.54-3.1-.76a38.17,38.17,0,0,0-6.52-.25,94.08,94.08,0,0,0-13.22,1.6,231.25,231.25,0,0,0-26,6.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "446.98 1134.05 446.08 1132.1 516.76 1099.48 487.32 1030.59 489.3 1029.74 519.56 1100.57 446.98 1134.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 453.34,
    y: 1435.81,
    width: 3.75,
    height: 322.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 342.71,
    y: 1405.71,
    width: 225.02,
    height: 44.43,
    rx: 22.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M412.66,1742.71h85.12a33.4,33.4,0,0,1,33.4,33.4v3.67a0,0,0,0,1,0,0H379.25a0,0,0,0,1,0,0v-3.67A33.4,33.4,0,0,1,412.66,1742.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 830.28,
    y: 1223.94,
    width: 3.75,
    height: 599.9,
    transform: "matrix(0.85, -0.53, 0.53, 0.85, -684.75, 679.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 532.21,
    y: 1522.02,
    width: 599.9,
    height: 3.75,
    transform: "translate(-900.67 1414.15) rotate(-57.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 551.72,
    y: 1249.48,
    width: 560.88,
    height: 42.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M598.74,575.11A117.22,117.22,0,1,1,716,457.89,117.35,117.35,0,0,1,598.74,575.11Zm0-231.93A114.72,114.72,0,1,0,713.45,457.89,114.84,114.84,0,0,0,598.74,343.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 678,
    cy: 411.97,
    r: 127.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "678.04 414.38 607.34 358.96 609.66 356 677.96 409.55 716.04 377.3 718.46 380.16 678.04 414.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.05,687H282.29a18.87,18.87,0,0,0-18.87,18.87v64.76a18.87,18.87,0,0,0,18.87,18.87H328.5L348.42,817V789.43a18.85,18.85,0,0,0,17.5-18.8V705.87A18.87,18.87,0,0,0,347.05,687Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M349.67,820.86l-21.81-30.11H282.29a20.14,20.14,0,0,1-20.12-20.12V705.87a20.14,20.14,0,0,1,20.12-20.12h64.76a20.15,20.15,0,0,1,20.12,20.12v64.76a20.19,20.19,0,0,1-17.5,19.93ZM282.29,688.25a17.63,17.63,0,0,0-17.62,17.62v64.76a17.63,17.63,0,0,0,17.62,17.62h46.85l18,24.89V788.27l1.16-.09a17.67,17.67,0,0,0,16.34-17.55V705.87a17.64,17.64,0,0,0-17.62-17.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "313.34 771.58 287.42 734.13 293.58 729.87 312.66 757.42 341.39 706 347.94 709.66 313.34 771.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 238,
    y: 1776.04,
    width: 1536.44,
    height: 3.75
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrers);
export default __webpack_public_path__ + "static/media/carrers.20103d8fb6f91b07b6a3cd70ea201084.svg";
export { ForwardRef as ReactComponent };